import { Table } from "react-bootstrap";

const GLXMAKEDATA = ({ output }) => {
    const headers = Object.keys(output?.row?.[0] || {});
    return (
        <Table className="m-0 border-start border-end custom-table" bordered hover striped>
            <thead>
                <tr>
                    {headers?.map(header => (
                        <th key={header}>{header}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {output?.row?.map((row, rowIdx) => (
                    <tr key={rowIdx}>
                        {headers?.map(header => (
                            <td key={header}>{row[header]}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default GLXMAKEDATA;
